import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getList(metricId) {
    return axiosIns.get(`/admin/report_metrics/${metricId}/report_metric_items`)
  },
  create(metricId, params) {
    return axiosIns.post(`/admin/report_metrics/${metricId}/report_metric_items`, { report_metric_item: snakecaseKeys(params) })
  },
  update(metricId, id, params) {
    return axiosIns.patch(`/admin/report_metrics/${metricId}/report_metric_items/${id}`, { report_metric_item: snakecaseKeys(params) })
  },
  destroy(metricId, id) {
    return axiosIns.delete(`/admin/report_metrics/${metricId}/report_metric_items/${id}`)
  },
  updatePositions(metricId, params) {
    return axiosIns.patch(`/admin/report_metrics/${metricId}/report_metric_items/update_positions`, snakecaseKeys(params))
  },
}
